export { default } from '../client/script'
export * from '../client/script'
